<template>
  <div :class="['addressList', isSelection ? 'selectionAddressList' : '']">
    <div class="address-title" v-if="!isSelection">
      <van-image width="15" height="15" :src="earthIcon"></van-image>
      <span class="label1">{{ $t.address.addressTitle }}</span>
    </div>
    <ul class="list">
      <li
        class="item"
        v-for="item in addressList"
        :key="item.CRId"
        @click="getEditAddress(item)"
      >
        <img
          class="default"
          v-if="item.IsDefult == 1"
          src="~assets/img/shippingAddress/icon_label@2x.png"
        />
        <div class="itemLeft">
          <section class="userBox">
            <p class="userName">{{ item.ReceivingName }}</p>
            <p class="userPhone">{{ item.PhoneNumber }}</p>
          </section>
          <p class="postcode">{{ $t.address.postcode }} : {{ item.PostalCode }}</p>
          <p class="address">{{ item.ReceivingAddress }}</p>
        </div>
        <figure class="itemRight">
          <div class="actionBox" v-if="!isSelection">
            <van-icon size="20" name="arrow" />
          </div>
          <div class="actionBox" v-if="isSelection" @click.stop="editAddress(item)">
            <van-icon size="20" name="edit" />
          </div>
        </figure>
      </li>
    </ul>
  </div>
</template>
<script>
import Vue from "vue";
import { Icon, Image } from "vant";

Vue.use(Icon).use(Image);

export default {
  name: "AddressList",
  props: ["addressList", "isSelection"],
  data() {
    return {
      earthIcon: require("@/assets/img/shippingAddress/earth.png"),
    };
  },
  methods: {
    getEditAddress(item) {
      this.$emit("addressDidTap", item);
    },
    editAddress(item) {
      this.$emit("editAddress", item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
@mixin publicP {
  color: #333333;
  font-size: 12px;
  margin-top: 10px;
}
.selectionAddressList {
  margin-bottom: 25vh !important;
}
.address-title {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4%;
  .van-image {
    vertical-align: middle;
  }
  .label1 {
    font-size: 14px;
    font-weight: 500;
    vertical-align: middle;
    display: inline-block;
    margin-left: 5px;
  }
}
.addressList {
  width: 92%;
  margin: 0 auto;
  margin-bottom: 15vh;
  * {
    margin: 0;
    padding: 0;
  }
  .list {
    width: 100%;
    .item {
      overflow: hidden;
      position: relative;
      width: 100%;
      margin-top: 15px;
      box-sizing: border-box;
      padding: 0 0 0 25px;
      -webkit-box-sizing: border-box;
      background-color: #ffffff;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      border-radius: 8px;
      box-shadow: 0px 2px 5px 0px rgb(0 0 0 / 30%);
      @include publicFlex;
      .default {
        position: absolute;
        left: -2px;
        top: -2px;
        border-top-left-radius: 10px;
        width: 50px;
      }
      .itemLeft {
        min-width: 75%;
        max-width: 75%;
        .userBox {
          padding-top: 20px;
          @include publicFlex;
          .userName {
            font-size: 14px;
            color: #000000;
            font-weight: bold;
          }
          .userPhone {
            font-size: 12px;
            color: #2750aa;
            margin-left: 22px;
            flex: 1;
            -wbkit-flex: 1;
          }
        }
        .postcode {
          @include publicP;
          color: #999;
        }
        .address {
          @include publicP;
          color: #999;
          padding-bottom: 20px;
        }
      }
      .itemRight {
        min-width: 20%;
        text-align: right;
        .actionBox {
          margin: 1rem 0;
          color: #999;
          text-align: center;
        }
      }
    }
  }
}
</style>
